import { createContext } from "react";
import { OlapScoresWithPrevScores } from "src/api/client-api/olapScores/olapScoresSchema";
import { ProductSummary } from "src/pages/Product/ProductDetails/useProductSummaryData";
import type { useGetProductScores } from "src/api/client-api/olapScores/useGetProductScores";

type ProductScoresQueryResult = ReturnType<typeof useGetProductScores>;

export type ProductScoresContextInitialValues = {
    scores: OlapScoresWithPrevScores | undefined;
    areScoresRefetching: boolean;
    scoreQueryError: ProductScoresQueryResult["error"];
    isScoreQueryError: ProductScoresQueryResult["isError"];
    retryScoreQuery: ProductScoresQueryResult["refetch"];

    productSummary: ProductSummary | null;
};

export const ProductScoresContext = createContext<ProductScoresContextInitialValues | null>(null);
